import { LOGGING } from '@/config';

/**
 * Фабрика логгера с фиксированным тегом файла (JS-версия)
 * @param {string} tag
 * @param {boolean} [localEnabled=true]    Локальный рубильник файла
 * @param {boolean} [moduleLogEnabled=true] Рубильник конкретного модуля/подсистемы
 */
export function makeLogger(tag, localEnabled = true, moduleLogEnabled = true) {
  const isEnabled = () => LOGGING.GLOBAL_DEBUG_LOG && localEnabled && moduleLogEnabled;
  const alwaysErr = () => LOGGING.ALWAYS_LOG_ERROR === true;

  const base = (method, step, message, ...extras) => {
    // error — всегда логируем, если включён ALWAYS_LOG_ERROR
    if (method === 'error') {
      if (!(isEnabled() || alwaysErr())) return;
    } else {
      if (!isEnabled()) return;
    }
    const header = `[${tag}] ${step}: ${message}`;
    // eslint-disable-next-line no-console
    console[method](header, ...extras);
  };

  const log = (s, m, ...extras) => base('log',  s, m, ...extras);
  log.info  = (s, m, ...extras) => base('log',  s, m, ...extras);
  log.warn  = (s, m, ...extras) => base('warn', s, m, ...extras);
  log.error = (s, m, ...extras) => base('error', s, m, ...extras);

  // «подлоггер» с фиксированными полями
  log.with = fixed => (step, message, ...extras) =>
    base('log', step, message, fixed, ...extras);

  return log;
}


